// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/regimen-alimenticio/list',
    name: 'regimen-alimenticio-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/RegimenAlimenticio.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_regimen_alimenticio',
    },
  },
]

export default formTable
